{
  "analysis": {
    "analysis_help_title": "Como usar as ferramentas",
    "analysis_help_description": "Use as ferramentas de desenho para desenhar uma linha ou área no mapa. Com um objeto selecionado, expanda as seções abaixo para mostrar diferentes tipos de análise."
  },
  "sidebarToolbar": {
    "delete_layer": "Excluir camada",
    "remove_layer": "Remover camada"
  },
  "sidebarLayers": {
    "emptyLayer": "{{ layerName }} ainda não tem nenhum objeto",
    "emptyGroup": "{{ groupName }} não tem camadas ou grupos"
  },
  "attributes": {
    "namingOrder": "Ordem de nomenclatura",
    "customerIdentifier": "Nome do identificador do cliente",
    "list_items": {
      "add_another_placeholder": "Adicionar outra opção de lista",
      "add_first_placeholder": "Adicionar uma opção de lista"
    },
    "dataDriven": {
      "canDo": "Estilo orientado por atributos",
      "noDatafields": "Adicione atributos para usar o estilo orientado por atributos",
      "label": "Definir usando atributos",
      "tour": {
        "stage_one": {
          "title": "Estilo orientado por atributos",
          "content": "Você precisa adicionar um atributo de lista antes de poder estilizar sua camada por valores de atributo"
        }
      }
    },
    "predefined_subtitle": "Escolha entre um conjunto de atributos prontos",
    "custom_subtitle": "Crie seu próprio atributo, como uma lista personalizada ou uma caixa de entrada de texto",
    "attribute_type": "Tipo de atributo",
    "create_new_attribute": "Crie um novo atributo escolhendo um tipo na lista abaixo e edite-o de acordo com seus requisitos",
    "edit_attribute": "Edite esse atributo escolhendo um tipo na lista abaixo e edite-o de acordo com seus requisitos",
    "edit_attribute_no_type": "Edite esse atributo usando os campos abaixo e edite-o de acordo com seus requisitos",
    "create_attribute_title": "Criar atributo",
    "edit_attribute_title": "Editar atributo",
    "add_attribute_subtitle": "Adicione um novo atributo escolhendo um predefinido ou criando um novo do zero",
    "predefined_info_title": "Atributos predefinidos",
    "predefined_info_text": "Os administradores do projeto podem gerenciá-los nas Configurações do projeto",
    "predefined_info_link": "Clique aqui para ir para “Configurações do projeto”",
    "create_predefined_title": "Criar atributo predefinido"
  },
  "styles": {
    "fill": "Preencher"
  },
  "layer_tour": {
    "tip_1_welcome": {
      "title": "Personalize sua camada",
      "content": "Você pode alterar a aparência da sua camada e quais informações (atributos) você deseja armazenar ao adicionar objetos ao plano."
    },
    "tip_2_name": {
      "title": "Nome da camada",
      "content": "Altere o nome da sua camada para ajudar a descrever o que você está adicionando ao plano"
    },
    "tip_3_attributes": {
      "title": "Atributos",
      "content": "Adicione atributos (opcional) para armazenar informações sobre objetos no plano. Por exemplo, você pode capturar tipos/categorias, custos, quantidades, datas ou qualquer outra coisa que precisar."
    },
    "tip_4_styles": {
      "title": "Estilos",
      "content": "Altere a aparência dos objetos nessa camada na planta, como cores e tamanhos."
    },
    "tip_5_attribute_styles": {
      "title": "Estilo baseado em atributos",
      "content": "Use atributos para determinar a aparência dos objetos. Por exemplo, diferentes 'tipos/categorias' podem ter cores diferentes."
    },
    "tip_6_save": {
      "title": "Salvar",
      "content": "Quando terminar, pressione salvar para adicionar a camada ao plano. Você sempre pode alterar essas configurações posteriormente, como adicionar mais atributos ou ajustar o estilo."
    }
  },
  "formula_summary": {
    "remove_formula": "Remover fórmula"
  },
  "layer_information": {
    "title": "Informações da camada",
    "owner_map_location": "Localização do plano do proprietário",
    "open_in_folder": "Abrir na pasta",
    "created_by": "Criado por",
    "created_on": "Criado em",
    "last_modified": "Última modificação",
    "permissions": "Permissões",
    "view_collaborators": "Visualize e edite colaboradores",
    "visualiser_overflow": "... {{ nodeCount }} mais pastas",
    "edit_style": "Configurações de camada"
  },
  "edit_layer": {
    "add_to_map": "Adicionar ao plano",
    "customise": "Personalize o modelo",
    "text_position": "Posição do texto",
    "text_offset": "Deslocamento de texto"
  },
  "style_errors": {
    "invalid_incrementor_value": "Valor inválido. Insira um valor entre {{ minValue }} e {{ maxValue }}"
  },
  "style": {
    "error": "Algo deu errado, as alterações da camada não foram salvas"
  },
  "toolbarButtonTooltips": {
    "confirm_action": "Desenho completo"
  }
}